import { useIonRouter, IonActionSheet, IonButton, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { newspaperOutline, imageOutline, videocamOutline, createOutline, imagesOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState, Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const ActionComp : React.FC<ContentInterface> = ({ content }) => {

    const router = useIonRouter();

    // add text
    const addContent = () => {
        router.push("/add/post", "forward", "push");
    }

    // action component clicked
    const onAction = () => {
        // check the type of action
        if (content.action.substring(0, 5) == 'https')
            // open the browser
            window.open(content.action);
        else
            router.push(content.action, 'forward', 'push');
    }

    if (content.action == null || content.action == "")
        return ( <div/> );

    return (
        <div className="ion-padding">
            <IonButton className="main-but act-but" expand="block" onClick={onAction}>
                { content.action_lbl }
            </IonButton>
        </div>
    );
};
  
export default ActionComp;